module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "store-list"
  }, _vm._l((_vm.data), function(store, index) {
    return _c('li', {
      staticClass: "item"
    }, [_c('dl', {
      staticClass: "shop-info"
    }, [_c('dt', {
      staticClass: "shop-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            store_id: store.storeId,
            tab: 1
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(store.storeName) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('dd', {
      staticClass: "shop-pic"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            store_id: store.storeId,
            tab: 1
          }
        },
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "size72"
    }, [_c('img', {
      staticClass: "size72",
      attrs: {
        "border": "0",
        "src": store.storeLogo || store.idImg,
        "alt": store.storeName
      }
    })])])], 1)]), _vm._v(" "), _c('dl', {
      staticClass: "w200"
    }, [_c('dd', [_vm._v("商品数量" + _vm._s(store.goodsNum) + "件")]), _vm._v(" "), _c('dd', [_vm._v("总成交" + _vm._s(store.buyNum) + "笔")]), _vm._v(" "), (store.goodsList.length > 0) ? _c('dd', {
      directives: [{
        name: "more-on-off",
        rawName: "v-more-on-off"
      }],
      staticClass: "more-on"
    }, [_c('span', [_vm._v("收起相关商品")]), _c('i')]) : _vm._e()]), _vm._v(" "), _c('dl', {
      staticClass: "w150"
    }, [_c('dd', [_vm._v("店铺好评率：" + _vm._s(store.praiseRate * 100) + "%")]), _vm._v(" "), _c('dd', {
      staticClass: "shop-rate",
      attrs: {
        "nc_type": "shop-rate",
        "store_id": "2"
      }
    }, [_vm._v("\n    \t\t\t\t店铺动态评分："), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "shop-rate-con"
    }, [_c('div', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('dl', {
      staticClass: "rate"
    }, [_c('dt', [_vm._v("描述相符：")]), _vm._v(" "), _c('dd', {
      staticClass: "rate-star"
    }, [_c('em', [_c('i', {
      style: ({
        width: store.storeDesccredit * 20 + '%'
      })
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(store.storeDesccredit ? store.storeDesccredit : '5') + "分")])]), _vm._v(" "), _c('dt', [_vm._v("服务态度：")]), _vm._v(" "), _c('dd', {
      staticClass: "rate-star"
    }, [_c('em', [_c('i', {
      style: ({
        width: store.storeServicecredit * 20 + '%'
      })
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(store.storeServicecredit ? store.storeServicecredit : '5') + "分")])]), _vm._v(" "), _c('dt', [_vm._v("发货速度：")]), _vm._v(" "), _c('dd', {
      staticClass: "rate-star"
    }, [_c('em', [_c('i', {
      style: ({
        width: store.storeDeliverycredit * 20 + '%'
      })
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(store.storeDeliverycredit ? store.storeDeliverycredit : '5') + "分")])])])])])]), _vm._v(" "), _c('dl', {
      staticClass: "w120"
    }, [_c('dd', {
      staticClass: "tr"
    }, [_vm._v(_vm._s(store.storeProvince) + " " + _vm._s(store.storeCity) + " " + _vm._s(store.storeRegion))])]), _vm._v(" "), (store.goodsList.length > 0) ? _c('div', {
      staticClass: "shop-goodslist"
    }, [_c('div', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('div', {
      staticClass: "jcarousel-skin-tango"
    }, [_vm._v(",\n      \t\t\t\t"), _c('div', {
      staticClass: "jcarousel-container jcarousel-container-horizontal",
      staticStyle: {
        "position": "relative",
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "jcarousel-clip jcarousel-clip-horizontal",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('ul', {
      staticClass: "jcarousel-list jcarousel-list-horizontal",
      staticStyle: {
        "overflow": "hidden",
        "position": "relative",
        "top": "0px",
        "margin": "0px",
        "padding": "0px",
        "left": "0px",
        "width": "1600px"
      },
      attrs: {
        "nc_type": "jcarousel"
      }
    }, _vm._l((store.goodsList), function(sgl, index2) {
      return _c('li', {
        staticClass: "jcarousel-item jcarousel-item-horizontal jcarousel-item-1 jcarousel-item-1-horizontal",
        staticStyle: {
          "float": "left",
          "list-style": "none",
          "width": "190px"
        },
        attrs: {
          "jcarouselindex": "1"
        }
      }, [_c('dl', [_c('dt', {
        staticClass: "goods-pic"
      }, [_c('span', {
        staticClass: "thumb size160"
      }, [_c('i'), _vm._v(" "), _c('router-link', {
        attrs: {
          "to": {
            path: '/goods',
            query: {
              goods_id: sgl.goodsId
            }
          },
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": sgl.thumbnail,
          "alt": sgl.name,
          "width": "160",
          "height": "160"
        }
      })])], 1)]), _vm._v(" "), _c('dd', {
        staticClass: "goods-name"
      }, [_c('router-link', {
        attrs: {
          "to": {
            path: '/goods',
            query: {
              goods_id: sgl.goodsId
            }
          },
          "title": sgl.name,
          "target": "_blank"
        }
      }, [_vm._v("\n\t\t            \t\t\t\t\t\t\t" + _vm._s(sgl.name) + "\n\t\t            \t\t\t\t\t\t")])], 1), _vm._v(" "), _c('dd', {
        staticClass: "goods-price"
      }, [_c('em', [_vm._v("¥" + _vm._s(sgl.price))])]), _vm._v(" "), _c('dd', {
        staticClass: "goods-sales"
      })])])
    }), 0)])])])]) : _vm._e()])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96045eaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/module-shopList.vue
// module id = 1654
// module chunks = 1